import {LocalDate} from '@js-joda/core';

export class AccountingPeriod {
  public id?: number;
  public closed?: boolean;
  public startDate: LocalDate = LocalDate.now();
  public endDate: LocalDate = LocalDate.now();
}
